import 'src/global.css';

// ----------------------------------------------------------------------

import {Provider as ReduxProvider} from 'react-redux';

import {Router} from 'src/routes/sections';

import {useScrollToTop} from 'src/hooks/use-scroll-to-top';

import {themeConfig, ThemeProvider} from 'src/theme';

import {ProgressBar} from 'src/components/progress-bar';
import {MotionLazy} from 'src/components/animate/motion-lazy';
import {SettingsDrawer, defaultSettings, SettingsProvider} from 'src/components/settings';

import {AuthProvider} from 'src/auth/context/firebase';

import {store} from './redux/store'
import {LocalizationProvider} from "./locales";


// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  return (
    <ReduxProvider store={store}>
      <AuthProvider>
        <SettingsProvider defaultSettings={defaultSettings}>
          <LocalizationProvider>
            <ThemeProvider
              noSsr
              defaultMode={themeConfig.defaultMode}
              modeStorageKey={themeConfig.modeStorageKey}>
              <MotionLazy>
                <ProgressBar/>
                <SettingsDrawer defaultSettings={defaultSettings}/>
                <Router/>
              </MotionLazy>
            </ThemeProvider>
          </LocalizationProvider>
        </SettingsProvider>
      </AuthProvider>
    </ReduxProvider>
  );
}
